import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import ErrorOutlineIcon from 'components/material-symbol/icons/Error'
import SectionEmptyState from 'components/section-empty-state'

// The golfer pages' load error, built from the shared /club empty state. It is
// deliberately not the coach side's `pga-coach/virtual-coaching/load-error`.
const LoadError = ({ error, title, onRetry }) => {
  useEffect(() => {
    if (error) {
      window.rg4js && window.rg4js('send', { error })
    }
  }, [error])

  return (
    <SectionEmptyState
      Icon={ErrorOutlineIcon}
      title={title}
      caption="Something went wrong on our end. Try again in a moment. If it keeps happening, contact support."
      action={
        onRetry ? (
          <Button variant="outlined" color="primary" onClick={onRetry}>
            Try again
          </Button>
        ) : null
      }
    />
  )
}

LoadError.propTypes = {
  error: PropTypes.object,
  title: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
}

export default LoadError
